import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  POLYGON_TYPE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.MESHY_MESH_SIMPLIFICATION_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.MESH_SIMPLIFICATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
      "target_polycount": {
        "type": "integer",
        "minimum": 10000,
        "maximum": 300000,
        "default": 150000,
      },
    },
    "required": ["input_3d"],
    "additionalProperties": false,
  },
  "ui_schema": {},
  "active_if": {
    "properties": {
      "smart_low_poly": { "const": false },
    },
  },
  "keyToConvert": [
    { "from": "polygon_type", "to": "topology" },
    { "from": "target_polycount", "to": "polycount" },
  ],
}
